import { BlockTitle } from 'framework7-react';

function AccessRestricted() {
  return (
    <div style={{ padding: '1rem' }}>
      <BlockTitle>Access Restricted</BlockTitle>
      <p>You must be logged in to view this content.</p>
    </div>
  );
}

export default AccessRestricted;